import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Field } from 'react-final-form-html5-validation';
import * as actions from '../../../actions';
import {
    conditionallyRequiredText,
    conditionallyRequiredSignature,
    conditionallyRequiredSignatureDate
} from '../../helpers/Validation';
import SignatureCanvas from 'react-signature-canvas';
import { textField } from '../../helpers/Form';
import SignatureDate from '../../hooks/SignatureDate';

class Step5Form extends Component {
    constructor(props) {
        super(props)
        this.state = {
            residentSignature: null,
            submitted: false,
            residentSignatureDate: null
        }
    }

    // Used to restore sigs
    componentDidMount() {
        const { residentSignature } = this.props.questionOptions; 

        const options = {
            minWidth: 0.5,
        }
        if (residentSignature) {
            this[("residentSignatureRef")].fromDataURL(residentSignature, options);
        }
    }

    clearSigCanvas = (refName) => {
        this[(refName + "Ref")].clear();
    }

    storeSigData = (refName) => {
        this.setState({
            ...this.state,
            [refName]: this[(refName + "Ref")].getTrimmedCanvas().toDataURL()
        })
        this.props.questionAnswer(refName, this[(refName + "Ref")].toDataURL());
    }
        
    render() {
        const { currentStep } = this.props;
        const { residentSignature } = this.state;
        const {
            authorizedRepresentative,
            authorizedRepresentativeTwo,
            relationshipToPatient,
            relationshipToPatientTwo,
            residentSignatureDate
        } = this.props.questionOptions;
        const todaysDate = new Date().toLocaleString("en-US", { month: "long", day: "numeric", year: "numeric" });

        return (
            <Fragment>
                <div className="row mobile-step-header">
                    <div className="col-sm-2 col-2">
                        <span className="header-number">{currentStep}</span>
                    </div>
                    <div className="col-sm-10 col-10 pl-3">
                        <h3 className="euclid">AUTHORIZATION &#38; SUBMISSION</h3>
                       
                        
                    </div>
                    <div class="row grey-spacer-col-1"></div>
                </div>

                <div className="spacer-medium">&nbsp;</div>
                <div className="row mobile-step-header">
                    <div className="col">
                        <h3 className="euclid">AUTHORIZATION TO DISCLOSE INFORMATION TO INDIVIDUALS INVOLVED IN MY CARE (optional)</h3>
                        <p style={{paddingTop: '5px'}}>I further authorize Acadia Pharmaceuticals Inc. to discuss the coordination of my care with the following family member(s) and/or caregiver(s):</p>
                    </div>
                </div>
                <div className="row spacer-medium">&nbsp;</div>
                <div className="row">
                    <div className="col-sm">
                        <Field
                            name="authorizedRepresentative"
                            label={"Authorized representative name"}
                            component={textField}
                            validate={conditionallyRequiredText(authorizedRepresentative || relationshipToPatient ? 1 : 0)}
                            key={authorizedRepresentative || relationshipToPatient ? 1 : 0}
                            onBlur={(event) => this.props.questionAnswer("authorizedRepresentative", event.target.value)}
                            customMobileTop="-22px"
                            customMobileLabelTop="-44px"
                        />
                    </div>
                    <div className="col-sm">
                        <Field
                            name="relationshipToPatient"
                            label={"Relationship to patient"}
                            component={textField}
                            validate={conditionallyRequiredText(authorizedRepresentative || relationshipToPatient ? 1 : 0)}
                            key={authorizedRepresentative || relationshipToPatient ? 1 : 0}
                            onBlur={(event) => this.props.questionAnswer("relationshipToPatient", event.target.value)}
                        />
                    </div>
                </div>
               
                <div className="hipaa form-group signature">
                    <Field
                        name="residentSignature"
                        defaultValue={residentSignature}
                        component="input"
                        key={(residentSignature || residentSignatureDate) ? 1 : 0}
                        validate={conditionallyRequiredSignature((residentSignature || residentSignatureDate) ? 1 : 0)}
                    >
                        {({ input, meta }) => (
                            <Fragment>
                                <label className={"blue " + meta.error && meta.touched ? "error signature-error" : "" } htmlFor="residentSignature">Patient/Legal guardian signature</label> 
                            </Fragment>
                        )}
                    </Field>
                    <div className="relative form-group bt-neg-10px-mobile">
                        <SignatureCanvas 
                        penColor='black' 
                        canvasProps={{height: 200, className: 'sig-canvas'}} 
                        onEnd={() => this.storeSigData("residentSignature")} 
                        ref={(ref) => { this.residentSignatureRef = ref }} 
                        clearOnResize={false}
                        />
                        <button type="button" className="canvas-clear" onClick={() => this.clearSigCanvas("residentSignature")}>CLEAR</button>
                        <Field
                            name="residentSignature"
                            defaultValue={residentSignature}
                            component="input"
                            key={(residentSignature || residentSignatureDate) ? 1 : 0}
                            validate={conditionallyRequiredSignature((residentSignature || residentSignatureDate) ? 1 : 0)}
                        >
                            {({ input, meta }) => (
                                <Fragment>
                                    <input {...input} type="text" className="form-control full-width-input hidden-field" tabindex="-1" />
                                    {meta.error && meta.touched && meta.error }
                                </Fragment>
                            )}
                        </Field>
                    </div>
                    <SignatureDate forDate="residentSignature"/>
                </div>
            </Fragment>
        )
    }
}

const mapStateToProps = (state) => {
    const { currentStep, questionOptions } = state;
    return { currentStep: currentStep, questionOptions: questionOptions };
}
  
export default connect(mapStateToProps, actions)(Step5Form);